( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        header: {
            autoHideTolerance: {
                down: 100,
                up: 500
            }
        },
        search: {
            result: {
                pages: {
                    url: jQuery( 'html' ).data( 'area-name' ) + '/system/data/search?q='
                },
                offices: {
                    url: jQuery( 'html' ).data( 'area-name' ) + '/system/data/offices'
                }
            }
        }
    } );

}() );